export default "__VITE_ASSET__Jxu1oAjF__"